/* Preserve uploaded files as private order properties; expose only their count at checkout. */
(function () {
  'use strict';
  if (window.LPCheckoutPhotos) return;
  var SUMMARY = 'Pet Photos';
  var PHOTO = /^(?:Pet Photos?|Upload Your Pet(?:'|’)?s Photos?)(?:\s*\(\d+\))?\s*:?$/i;
  var requestInfo = new WeakMap();
  var resumedForms = new WeakSet();
  var preparing = null;

  function isPhoto(key, value) {
    return PHOTO.test(String(key).replace(/^_+/, '')) &&
      typeof value === 'string' && /^https?:\/\//i.test(value) &&
      /\/front\/files\/|\/files\/|\/uploads\/|cdn\.shopify\.com/i.test(value);
  }

  function normalize(properties) {
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) return properties;
    var result = {};
    var photos = new Set();
    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (isPhoto(key, value)) {
        var privateKey = '_' + key.replace(/^_+/, '');
        // A public and private copy of the same field count as one uploaded photo.
        if (!Object.prototype.hasOwnProperty.call(result, privateKey) || key.charAt(0) !== '_') {
          result[privateKey] = value;
        }
        photos.add(privateKey);
      } else {
        result[key] = value;
      }
    });
    // APO's cart transform supplies the expandable component details separately.
    // Keep its price and configuration intact, changing only photo display attributes.
    if (typeof result.__mws_apo_cta === 'string') {
      try {
        var component = JSON.parse(result.__mws_apo_cta);
        if (component && Array.isArray(component.attributes)) {
          var componentPhotos = new Set();
          var attributes = component.attributes.map(function (attribute) {
            if (!attribute || !isPhoto(attribute.key, attribute.value)) return attribute;
            var privateKey = '_' + attribute.key.replace(/^_+/, '');
            componentPhotos.add(privateKey);
            return Object.assign({}, attribute, { key: privateKey });
          });
          if (componentPhotos.size) {
            var summary = componentPhotos.size + (componentPhotos.size === 1 ? ' photo uploaded' : ' photos uploaded');
            var summaryIndex = attributes.findIndex(function (attribute) { return attribute && attribute.key === SUMMARY; });
            if (summaryIndex < 0) attributes.push({ key: SUMMARY, value: summary });
            else attributes[summaryIndex] = Object.assign({}, attributes[summaryIndex], { value: summary });
            result.__mws_apo_cta = JSON.stringify(Object.assign({}, component, { attributes: attributes }));
          }
        }
      } catch (_) { /* An unknown app metadata format must remain byte-for-byte intact. */ }
    }
    if (photos.size) result[SUMMARY] = photos.size + (photos.size === 1 ? ' photo uploaded' : ' photos uploaded');
    return result;
  }

  // APO's cart transform expands a line into the checkout "Show/Hide N item(s)"
  // panel when __mws_apo_cta is present. Stripping it just before checkout keeps
  // the gift line, the prices and every customer property, but leaves
  // has_components=false so checkout renders an ordinary line item.
  function checkoutProperties(properties) {
    var result = normalize(properties);
    if (!result || typeof result !== 'object' || !Object.prototype.hasOwnProperty.call(result, '__mws_apo_cta')) return result;
    var copy = Object.assign({}, result);
    delete copy.__mws_apo_cta;
    return copy;
  }
  // Keep the frame preview for cart rendering while APO supplies the native main image to checkout.
  var REPLACE_IMAGE = '__mws_apo_cart_replace_image';
  var FRAME_IMAGE = '_lp_cart_frame';
  var FRAME_RATIO = '_lp_cart_ratio';
  var FRAME_ALT = '_lp_cart_alt';
  var FRAME_GROUP = '_lp_cart_group';
  var CHECKOUT_IMAGE = '_lp_checkout_image';

  function imageURL(value) {
    try {
      var url = new URL(value, location.href);
      return url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' ||
        (url.origin === location.origin && url.pathname.indexOf('/cdn/shop/') === 0)) ? url.href : '';
    } catch (_) { return ''; }
  }

  function bundleParent(properties) {
    if (!properties || properties._mws_option || !imageURL(properties[REPLACE_IMAGE])) return false;
    if (!(properties._mws_cart || properties.__mws_apo_cart)) return false;
    try { return Array.isArray(JSON.parse(properties.__mws_apo_cta).attributes); }
    catch (_) { return false; }
  }

  function isPortrait(product) {
    return product && Array.isArray(product.tags) && product.tags.some(function (tag) {
      return /^(2d|3d)-/i.test(tag);
    });
  }

  function cartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  async function readCart() {
    var response = await originalFetch.call(window, cartRoot() + 'cart.js', {
      credentials: 'same-origin', cache: 'no-store'
    });
    if (!response.ok) throw new Error('Unable to check your cart. Please try again.');
    return response.json();
  }

  // Reuse only image dimensions, never cart contents or prices. Keys include the full URL/version.
  var imageSizes = new Map();
  function imageSize(url) {
    if (imageSizes.has(url)) return imageSizes.get(url);
    var pending = new Promise(function (resolve) {
      var image = new Image();
      var timer = window.setTimeout(function () { finish(null); }, 5000);
      function finish(ratio) {
        window.clearTimeout(timer);
        image.onload = image.onerror = null;
        resolve(ratio);
      }
      image.onload = function () { finish(image.naturalHeight ? image.naturalWidth / image.naturalHeight : null); };
      image.onerror = function () { finish(null); };
      image.src = url;
    });
    imageSizes.set(url, pending);
    if (imageSizes.size > 32) imageSizes.delete(imageSizes.keys().next().value);
    pending.then(function (ratio) {
      // A failed pre-read must not prevent the original add-time fallback from retrying.
      if (!(ratio > 0) && imageSizes.get(url) === pending) imageSizes.delete(url);
    });
    return pending;
  }

  function isPortraitPreparation(input, method) {
    try {
      var init = window.mwApoInit;
      var url = new URL(input, location.href);
      return String(method).toUpperCase() === 'POST' && document.body &&
        document.body.classList.contains('lp-portrait-pdp') && isPortrait(init && init.product) &&
        url.protocol === 'https:' && url.hostname === 'apo-admin.mageworx.com' &&
        url.pathname === '/front/product/' + init.shop_domain + '/cart';
    } catch (_) { return false; }
  }

  function warmPortraitImage(payload) {
    var product = window.mwApoInit && window.mwApoInit.product;
    var properties = payload && payload.properties;
    if (!payload || !isPortrait(product) || payload.product_handle !== product.handle || !bundleParent(properties)) return;
    var frame = imageURL(properties[REPLACE_IMAGE]);
    if (frame && frame !== imageURL(product.featured_image)) imageSize(frame);
  }

  async function portraitProperties(properties, product, item) {
    if (!bundleParent(properties) || !isPortrait(product)) return properties;
    var main = imageURL(product.featured_image);
    var current = imageURL(properties[REPLACE_IMAGE]);
    if (!main || !current) return properties;
    var group = String(properties._mws_cart || properties.__mws_apo_cart);
    var saved = properties[FRAME_GROUP] === group && imageURL(properties[CHECKOUT_IMAGE]) === current &&
      imageURL(properties[FRAME_IMAGE]) && Number(properties[FRAME_RATIO]) > 0;
    if (current === main) return properties;
    var frame = saved ? imageURL(properties[FRAME_IMAGE]) : current;
    var featured = item && item.featured_image;
    var ratio = saved ? Number(properties[FRAME_RATIO]) :
      featured && imageURL(featured.url) === frame ? Number(featured.aspect_ratio) : await imageSize(frame);
    if (!(ratio > 0)) return properties;
    var result = Object.assign({}, properties);
    result[FRAME_IMAGE] = frame;
    result[FRAME_RATIO] = String(ratio);
    result[FRAME_ALT] = saved ? properties[FRAME_ALT] : featured && imageURL(featured.url) === frame ? featured.alt || '' : product.title || '';
    result[FRAME_GROUP] = group;
    result[CHECKOUT_IMAGE] = main;
    result[REPLACE_IMAGE] = main;
    return result;
  }

  function productReader() {
    var products = new Map();
    return function (handle) {
      if (!handle || !/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return Promise.resolve(null);
      if (!products.has(handle)) products.set(handle, new Promise(function (resolve) {
        var controller = new AbortController();
        var timer = window.setTimeout(function () { controller.abort(); resolve(null); }, 6000);
        originalFetch.call(window, cartRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal
        }).then(function (response) { return response.ok ? response.json() : null; })
          .then(resolve, function () { resolve(null); }).finally(function () { window.clearTimeout(timer); });
      }));
      return products.get(handle);
    };
  }

  function hasImageOverride(body) {
    if (typeof body === 'string') return body.indexOf(REPLACE_IMAGE) !== -1;
    if (!(body instanceof FormData || body instanceof URLSearchParams)) return false;
    var found = false;
    body.forEach(function (_, name) { if (name.indexOf('[' + REPLACE_IMAGE + ']') !== -1) found = true; });
    return found;
  }

  async function prepareImageBody(body) {
    // Return the original encoding and all unrelated fields, including APO pricing/configuration.
    var payload, fields, asString = typeof body === 'string';
    try {
      if (asString && /^\s*\{/.test(body)) payload = JSON.parse(body);
      else if (body instanceof FormData || body instanceof URLSearchParams) fields = body;
      else if (asString && /(?:^|&)(?:properties|items)(?:%5B|\[)/i.test(body)) fields = new URLSearchParams(body);
      else return body;
      var entries = [];
      if (payload) {
        (Array.isArray(payload.items) ? payload.items : [payload]).forEach(function (item) {
          if (item && bundleParent(item.properties)) entries.push({ item: item, properties: item.properties, id: item.id, line: item.line });
        });
      } else {
        var groups = new Map();
        fields.forEach(function (value, name) {
          var match = /^(properties|items\[\d+\]\[properties\])\[(.*)\]$/.exec(name);
          if (!match) return;
          if (!groups.has(match[1])) groups.set(match[1], {});
          groups.get(match[1])[match[2]] = value;
        });
        groups.forEach(function (properties, prefix) {
          if (!bundleParent(properties)) return;
          var match = /^items\[(\d+)\]/.exec(prefix);
          entries.push({ prefix: prefix, properties: properties,
            id: fields.get(match ? 'items[' + match[1] + '][id]' : 'id'), line: fields.get('line') });
        });
      }
      if (!entries.length) return body;
      var cart, changed = false, readProduct = productReader();
      for (var index = 0; index < entries.length; index++) {
        var entry = entries[index], item, handle;
        var currentProduct = window.mwApoInit && window.mwApoInit.product;
        if (currentProduct && Array.isArray(currentProduct.variants) && currentProduct.variants.some(function (variant) {
          return String(variant.id) === String(entry.id);
        })) handle = currentProduct.handle;
        if (!handle) {
          if (!cart) cart = await readCart();
          item = cart.items.find(function (line, position) {
            return entry.id ? line.key === String(entry.id) || String(line.variant_id) === String(entry.id) : position + 1 === Number(entry.line);
          });
          handle = item && item.handle;
        }
        var product = currentProduct && currentProduct.handle === handle ? currentProduct : await readProduct(handle);
        if (item && product && String(product.id) !== String(item.product_id)) continue;
        var properties = await portraitProperties(entry.properties, product, item);
        if (properties === entry.properties) continue;
        changed = true;
        if (payload) entry.item.properties = properties;
        else {
          Object.keys(entry.properties).forEach(function (key) { fields.delete(entry.prefix + '[' + key + ']'); });
          Object.keys(properties).forEach(function (key) { fields.append(entry.prefix + '[' + key + ']', properties[key]); });
        }
      }
      return changed ? payload ? JSON.stringify(payload) : asString ? fields.toString() : fields : body;
    } catch (_) { return body; } // An unavailable image must never discard an add or an option edit.
  }

  async function prepareCartImages(cart) {
    var readProduct = productReader();
    var parents = cart.items.filter(function (item) { return bundleParent(item.properties); });
    for (var index = 0; index < parents.length; index++) {
      var item = parents[index];
      var product = await readProduct(item.handle);
      if (!product || String(product.id) !== String(item.product_id)) continue;
      var properties = await portraitProperties(item.properties, product, item);
      if (properties === item.properties) continue;
      // Recheck after the product read: never replace properties from a concurrent option/quantity edit.
      cart = await readCart();
      var current = cart.items.find(function (line) { return line.key === item.key; });
      if (!current || current.quantity !== item.quantity || JSON.stringify(current.properties) !== JSON.stringify(item.properties)) continue;
      var response = await originalFetch.call(window, cartRoot() + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: current.key, quantity: current.quantity, properties: properties })
      });
      if (!response.ok) throw new Error('Unable to prepare your product image. Please try again.');
      cart = await response.json();
    }
    return cart;
  }

  var cartImagesPending = null;
  function prepareExistingCart() {
    if (cartImagesPending) return cartImagesPending;
    if (!document.querySelector('[data-lp-portrait-checkout-image]')) return;
    // Native wallets bypass a theme submit handler. Keep them inert only while an existing cart is prepared.
    var wallets = Array.from(document.querySelectorAll('.cart__dynamic-checkout-buttons, [data-shopify="dynamic-checkout-cart"], shopify-accelerated-checkout-cart'));
    var previous = wallets.map(function (wallet) { return wallet.hasAttribute('inert'); });
    wallets.forEach(function (wallet) { wallet.setAttribute('inert', ''); });
    cartImagesPending = readCart().then(prepareCartImages).catch(function () {
      // The existing checkout handler will retry; preserve all payment controls on failure.
    }).finally(function () {
      wallets.forEach(function (wallet, index) { if (!previous[index]) wallet.removeAttribute('inert'); });
      cartImagesPending = null;
    });
    return cartImagesPending;
  }

  function normalizePayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;
    if (Array.isArray(payload.items)) {
      return Object.assign({}, payload, { items: payload.items.map(function (item) {
        return item && item.properties ? Object.assign({}, item, { properties: normalize(item.properties) }) : item;
      }) });
    }
    return payload.properties ? Object.assign({}, payload, { properties: normalize(payload.properties) }) : payload;
  }

  function normalizeFields(body) {
    var groups = new Map();
    body.forEach(function (value, name) {
      var match = /^(properties|items\[\d+\]\[properties\])\[(.*)\]$/.exec(name);
      if (!match) return;
      if (!groups.has(match[1])) groups.set(match[1], {});
      groups.get(match[1])[match[2]] = value;
    });
    var result = body instanceof FormData ? new FormData() : new URLSearchParams();
    body.forEach(function (value, name) {
      if (!/^(properties|items\[\d+\]\[properties\])\[(.*)\]$/.test(name)) result.append(name, value);
    });
    groups.forEach(function (properties, prefix) {
      var normalized = normalize(properties);
      Object.keys(normalized).forEach(function (key) { result.append(prefix + '[' + key + ']', normalized[key]); });
    });
    return result;
  }

  function normalizeBody(body) {
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) return normalizeFields(body);
      if (typeof body !== 'string') return body;
      if (/^\s*\{/.test(body)) return JSON.stringify(normalizePayload(JSON.parse(body)));
      if (/(?:^|&)(?:properties|items)(?:%5B|\[)/i.test(body)) return normalizeFields(new URLSearchParams(body)).toString();
    } catch (_) { /* Preserve the original request if its encoding isn't supported. */ }
    return body;
  }

  function isCartWrite(input, method) {
    try {
      var url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.href);
      return String(method || 'GET').toUpperCase() === 'POST' && url.origin === location.origin &&
        /\/cart\/(?:add|change)(?:\.js)?\/?$/.test(url.pathname);
    } catch (_) { return false; }
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, options) {
    var receiver = this;
    if (options && options.body && isCartWrite(input, options.method || (input && input.method))) {
      var normalized = normalizeBody(options.body);
      if (!hasImageOverride(normalized)) return originalFetch.call(receiver, input, Object.assign({}, options, { body: normalized }));
      return prepareImageBody(normalized).then(function (body) {
        return originalFetch.call(receiver, input, Object.assign({}, options, { body: body }));
      });
    }
    return originalFetch.call(this, input, options);
  };
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  var originalAbort = XMLHttpRequest.prototype.abort;
  XMLHttpRequest.prototype.open = function (method, url) {
    requestInfo.set(this, { write: isCartWrite(String(url), method), warm: isPortraitPreparation(String(url), method), async: arguments[2] !== false, aborted: false });
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.abort = function () {
    var info = requestInfo.get(this);
    if (info) info.aborted = true;
    return originalAbort.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this, info = requestInfo.get(xhr);
    if (info && info.warm && info.async) {
      // Read the existing successful APO response while its gift/cart work continues.
      xhr.addEventListener('load', function () {
        if (info.aborted || requestInfo.get(xhr) !== info || xhr.status < 200 || xhr.status >= 300) return;
        try {
          var response = xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText);
          warmPortraitImage(response);
          reconcilePortraitAdd(response);
        } catch (_) { /* Preparation is optional; the original add-time path remains available. */ }
      }, { once: true });
    }
    if (!info || !info.write) return originalSend.call(xhr, body);
    var normalized = normalizeBody(body);
    if (!info.async || !hasImageOverride(normalized)) return originalSend.call(xhr, normalized);
    prepareImageBody(normalized).then(function (prepared) {
      if (!info.aborted && requestInfo.get(xhr) === info) originalSend.call(xhr, prepared);
    });
  };
  document.addEventListener('formdata', function (event) {
    var form = event.target;
    if (!form || !isCartWrite(form.action, form.method)) return;
    var normalized = normalizeFields(event.formData);
    var names = [];
    event.formData.forEach(function (_, name) { if (names.indexOf(name) === -1) names.push(name); });
    names.forEach(function (name) { event.formData.delete(name); });
    normalized.forEach(function (value, name) { event.formData.append(name, value); });
  }, true);

  async function prepareCheckout(verifiedCart) {
    if (preparing) return preparing;
    preparing = (async function () {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var cart = verifiedCart;
      var response;
      // A just-finished add may still be reconciling a duplicate; never redirect on an untidied cart.
      await reconcileChain;
      if (cartImagesPending) { await cartImagesPending; cart = null; }
      if (!cart || !Array.isArray(cart.items)) {
        response = await originalFetch.call(window, root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Unable to check your uploaded photos. Please try again.');
        cart = await response.json();
      }
      // Image overrides rely on bundleParent(), which needs __mws_apo_cta; run
      // them before that metadata is stripped from the cart.
      cart = await prepareCartImages(cart);
      var remaining = cart.items.length;
      while (remaining-- > 0) {
        var line = cart.items.find(function (item) {
          return JSON.stringify(item.properties || {}) !== JSON.stringify(checkoutProperties(item.properties || {}));
        });
        if (!line) return cart;
        response = await originalFetch.call(window, root + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: checkoutProperties(line.properties) })
        });
        if (!response.ok) throw new Error('Unable to prepare your uploaded photos. Please try again.');
        cart = await response.json();
      }
      if (cart.items.some(function (item) {
        return JSON.stringify(item.properties || {}) !== JSON.stringify(normalize(item.properties || {}));
      })) throw new Error('Your cart changed. Please review it and try again.');
      return prepareCartImages(cart);
    })();
    try { return await preparing; } finally { preparing = null; }
  }

  function showError(form, error) {
    var message = form.querySelector('[data-lp-photo-checkout-error]');
    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-lp-photo-checkout-error', '');
      message.setAttribute('role', 'alert');
      form.appendChild(message);
    }
    message.textContent = error.message || 'Unable to prepare your uploaded photos. Please try again.';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var button = event.submitter;
    if (!button || button.name !== 'checkout' || resumedForms.has(form)) return;
    var action;
    try { action = new URL(form.action, location.href); } catch (_) { return; }
    if (action.origin !== location.origin || !/\/cart\/?$/.test(action.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.lpPhotoCheckoutPending) return;
    form.dataset.lpPhotoCheckoutPending = 'true';
    prepareCheckout().then(function () {
      var error = form.querySelector('[data-lp-photo-checkout-error]');
      if (error) error.remove();
      resumedForms.add(form);
      try { form.requestSubmit(button); } finally { resumedForms.delete(form); }
    }).catch(function (error) { showError(form, error); }).finally(function () { delete form.dataset.lpPhotoCheckoutPending; });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareExistingCart, { once: true });
  else prepareExistingCart();
  window.addEventListener('pageshow', function (event) { if (event.persisted) prepareExistingCart(); });

  function normalizeForReceipt(properties) {
    var result = normalize(properties);
    if (!bundleParent(result)) return result;
    var group = String(result._mws_cart || result.__mws_apo_cart);
    var frame = imageURL(result[FRAME_IMAGE]);
    if (frame && result[FRAME_GROUP] === group && imageURL(result[CHECKOUT_IMAGE]) === imageURL(result[REPLACE_IMAGE])) {
      return Object.assign({}, result, { [REPLACE_IMAGE]: frame });
    }
    return result;
  }

  function text(value) {
    return Array.isArray(value) ? value.join(', ') : value == null ? '' : String(value);
  }

  function configurationSignature(properties) {
    var flat = {};
    Object.keys(properties || {}).forEach(function (key) {
      if (!/^(?:__?mws_|_lp_)/.test(key)) flat[key] = text(properties[key]);
    });
    var normalized = normalize(flat) || {};
    return JSON.stringify(Object.keys(normalized).sort().map(function (key) {
      return [key, text(normalized[key])];
    }));
  }

  var reconcileChain = Promise.resolve();

  function removeLine(key) {
    return originalFetch.call(window, cartRoot() + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).catch(function () { /* Housekeeping never blocks the add or checkout. */ });
  }

  function reconcilePortraitAdd(payload) {
    var properties;
    try { if (!payload || !bundleParent(properties = payload.properties)) return; } catch (_) { return; }
    var entity = text(payload.id || properties._mws_cart || properties.__mws_apo_cart);
    var variant = text(payload.variant_id);
    var signature = configurationSignature(properties);
    if (!entity || !variant) return;
    // Serialize: two in-flight adds must resolve against the same final cart.
    reconcileChain = reconcileChain.then(async function () {
      var related = (await readCart()).items.filter(function (line) {
        return String(line.variant_id) === variant && configurationSignature(line.properties) === signature;
      });
      // Keep an existing line; drop only the lines this add created, gift children included.
      var stale = related.filter(function (line) {
        return text((line.properties || {})._mws_cart || (line.properties || {}).__mws_apo_cart) === entity;
      });
      if (related.length < 2 || stale.length >= related.length) return;
      for (var index = 0; index < stale.length; index++) await removeLine(stale[index].key);
      // Keep the drawer and cart bubble in step with the tidied cart.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lp-checkout-photos' });
      }
    }).catch(function () { /* Housekeeping never blocks the add or checkout. */ });
  }

  window.LPCheckoutPhotos = { normalize: normalizeForReceipt, prepareCheckout: prepareCheckout };
})();
